import React, { useMemo } from "react";
import { Alert, Space, Tag, Typography } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { getAgentStatusLabel } from "../../lib/agentTrackUtils";

const { Text } = Typography;

const ACTIVE_STATUSES = new Set(["PENDING", "PROCESSING", "RUNNING"]);

function countActiveSessions(sessions = []) {
    return sessions.filter((session) => ACTIVE_STATUSES.has(String(session?.status || "").toUpperCase())).length;
}

const AgentExecutionIndicator = ({ sessions = [], isFetching = false }) => {
    const activeCount = countActiveSessions(sessions);
    const displayCount = activeCount || sessions.length || 1;

    const statusCounts = useMemo(
        () =>
            sessions.reduce((accumulator, session) => {
                const status = String(session?.status || "UNKNOWN").toUpperCase();
                accumulator[status] = (accumulator[status] || 0) + 1;
                return accumulator;
            }, {}),
        [sessions],
    );

    return (
        <Alert
            className="schedule-draft-agent-execution-indicator"
            type="info"
            showIcon
            icon={<SyncOutlined spin />}
            message={
                <Space wrap size={[8, 4]}>
                    <Text strong>{displayCount} 个 Agent 执行中</Text>
                    <Tag color="processing">编辑已锁定</Tag>
                    {isFetching ? <Tag>同步状态...</Tag> : null}
                    {Object.entries(statusCounts).map(([status, count]) => (
                        <Tag key={status}>{`${getAgentStatusLabel(status)} ${count}`}</Tag>
                    ))}
                </Space>
            }
        />
    );
};

export default AgentExecutionIndicator;
